import React from 'react';
import { Icon } from './Icon.js';
export const IconNotepad = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M20 22H4V4H20V22Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M16 15H8V10H16V15Z", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", "data-color": "color-2", fill: "none" }),
        React.createElement("path", { d: "M12 6V2", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M16 6V2", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M8 6V2", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" })));
};
//# sourceMappingURL=IconNotepad.js.map